
export const DEFAULT_SVG_ICON_SIZE = '35px';

export const PROGRESS_KEY = Object.freeze({
    IDENTIFY: 'schedule.progressIdentify',
    SERVICE: 'schedule.progressService',
    EMPLOYEE: 'schedule.progressEmployee',
    TIME_ALIGNMENT: 'schedule.progressTimeAlignment',
    PAYMENT: 'schedule.payment'
})

export const TIMING_FRAMES = [
    {
        label: 'schedule.morning',
        value: 'morning',
        checked: true
    },
    {
        label: 'schedule.noon',
        value: 'noon',
        checked: true
    },
    {
        label: 'schedule.evening',
        value: 'evening',
        checked: true
    }
];


export const GENERAL_TIME_OPTIONS = [
    {
        label: 'schedule.asap',
        value: 'asap',
        translateName: true,
        icon: `<svg width="inherit" height="inherit" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
 <path d="m77.641 249.58c-5.5 0-9.9609 4.4414-9.9609 9.9414s4.3984 9.9805 9.8789 9.9805l71-0.019531c5.5 0 9.9609-4.4609 9.9609-9.9609s-4.4609-9.9609-9.9609-9.9609zm208.92-96.797c-5.5 0-9.9414 4.4609-9.9414 9.9609v113.5c0 3 1.3203 5.6992 3.4219 7.5195l55.379 54.801c1.9414 1.9219 4.4609 2.8594 7 2.8594 2.5586 0 5.1211-0.98047 7.0781-2.9414 3.8594-3.9219 3.8203-10.219-0.078125-14.078l-52.898-52.301v-109.36c0-5.5-4.4609-9.9609-9.9609-9.9609zm-46.48-91.418h-0.058593c-5.5 0-9.9414 4.4414-9.9609 9.9414 0 5.5 4.4609 9.9609 9.9609 9.9609l36.602 0.019531-0.039062 20.898c-53.422 3.0195-100.42 30.078-130.32 70.559h-38.52c-5.5 0-9.9414 4.4609-9.9414 9.9414 0 5.5 4.4414 9.9609 9.9414 9.9609h93.219c5.5 0 9.9609-4.4609 9.9609-9.9609s-4.4609-9.9609-9.9609-9.9609l-29 0.019532c28.262-31.281 69.141-50.922 114.62-50.922 85.277 0 154.42 69.141 154.42 154.42 0 85.301-69.141 154.44-154.44 154.44-60.059 0-112.12-34.301-137.66-84.363h24.539c5.5 0 9.9609-4.4609 9.9609-9.9609s-4.4609-9.9609-9.9609-9.9609h-112.42c-5.5 0-9.9414 4.4609-9.9414 9.9609s4.4414 9.9609 9.9414 9.9609h65.859c26.961 61.379 88.32 104.28 159.68 104.28 96.301 0 174.36-78.059 174.36-174.36 0-56.844-27.219-107.34-69.32-139.16l11.359-19.738 14.16 8.1602c1.5586 0.89844 3.2812 1.3398 4.9609 1.3398 3.4414 0 6.7812-1.8008 8.6406-4.9805 2.7383-4.7617 1.1016-10.859-3.6602-13.602l-45.539-26.301c-1.5586-0.92188-3.2812-1.3398-4.9609-1.3398-3.4414 0-6.7812 1.7812-8.6406 4.9805-2.7383 4.7617-1.1211 10.84 3.6406 13.602l14.16 8.1797-10.738 18.578c-23.219-13.699-49.898-22.16-78.418-23.781l-0.039063-20.898 36.578-0.019531c5.5 0 9.9609-4.4609 9.9609-9.9414 0-5.5-4.4609-9.9609-9.9609-9.9609z"/>
</svg>`,
        isSvg: true

    },
    {
        label: 'schedule.pickADate',
        value: 'customDate',
        datePicker: true,
        translateName: true,
        icon: `<svg width="inherit" height="inherit" version="1.1" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
 <path d="m448 508h-384c-24.266 0-44-19.734-44-44v-384c0-24.266 19.734-44 44-44h384c24.266 0 44 19.734 44 44v384c0 24.266-19.734 44-44 44zm-384-448c-11.031 0-20 8.9688-20 20v384c0 11.031 8.9688 20 20 20h384c11.031 0 20-8.9688 20-20v-384c0-11.031-8.9688-20-20-20z"/>
 <path d="m464 156h-416c-6.625 0-12-5.375-12-12s5.375-12 12-12h416c6.625 0 12 5.375 12 12s-5.375 12-12 12z"/>
 <path d="m112 92c-6.625 0-12-5.375-12-12v-64c0-6.625 5.375-12 12-12s12 5.375 12 12v64c0 6.625-5.375 12-12 12z"/>
 <path d="m256 92c-6.625 0-12-5.375-12-12v-64c0-6.625 5.375-12 12-12s12 5.375 12 12v64c0 6.625-5.375 12-12 12z"/>
 <path d="m400 92c-6.625 0-12-5.375-12-12v-64c0-6.625 5.375-12 12-12s12 5.375 12 12v64c0 6.625-5.375 12-12 12z"/>
 <path d="m242.81 358.84c-3.0703 0-6.1406-1.1719-8.4844-3.5156l-27.32-27.312c-4.6875-4.6875-4.6875-12.281 0-16.969s12.281-4.6875 16.969 0l18.836 18.828 45.211-45.203c4.6875-4.6875 12.281-4.6875 16.969 0s4.6875 12.281 0 16.969l-53.695 53.688c-2.3438 2.3438-5.4141 3.5156-8.4844 3.5156z"/>
 <path d="m256 444c-68.375 0-124-55.625-124-124s55.625-124 124-124 124 55.625 124 124-55.625 124-124 124zm0-224c-55.141 0-100 44.859-100 100s44.859 100 100 100 100-44.859 100-100-44.859-100-100-100z"/>
</svg>`,
        customSize: '30px',
        isSvg: true

    },
];

export const ANY_EMPLOYEE = {
    EmployeeId: -1,
    FirstName: 'schedule.noMatterWhichEmployee',
    translateName: true,
    important: true,
    icon: `<svg width="inherit" height="inherit" version="1.1" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
 <path d="m256 74.668c100.05 0 181.33 81.281 181.33 181.33 0 100.05-81.281 181.33-181.33 181.33-100.05 0-181.33-81.277-181.33-181.33s81.277-181.33 181.33-181.33m0-32c-117.76 0-213.33 95.57-213.33 213.33s95.574 213.33 213.33 213.33c117.76 0 213.33-95.574 213.33-213.33 0-117.76-95.57-213.33-213.33-213.33z"/>
 <path d="m243.62 336c-4.2656 0-8.3203-1.707-11.309-4.6914l-65.281-65.066c-6.1875-6.1875-6.1875-16.426 0-22.613s16.426-6.1875 22.613 0l53.762 53.547 100.27-103.89c6.1875-6.3984 16.215-6.6133 22.613-0.42578 6.3984 6.1875 6.6133 16.215 0.42578 22.613l-111.57 115.62c-2.9883 3.1992-7.0391 4.9062-11.309 4.9062z"/>
</svg>`,
    isSvg: true,
    customSize: '40px'
};


export const DEFAULT_PROGRESS = [
    {
        label: PROGRESS_KEY.IDENTIFY,
        value: null
    },
    {
        label: PROGRESS_KEY.SERVICE,
        value: null
    },
    {
        label: PROGRESS_KEY.EMPLOYEE,
        value: null
    },
    {
        label: PROGRESS_KEY.TIME_ALIGNMENT,
        value: null
    },
    {
        label: PROGRESS_KEY.PAYMENT,
        value: null
    }
];

export const GENDER_TYPE = Object.freeze({
    MALE: 'm',
    FEMALE: 'w',
    ANY: 'e'
});

export const SIMULTANEOUS_SERVICE_SCHEDULING_TYPE = Object.freeze({
    BOTH: 'both',
    PARALLEL: 'parallel',
    WATERFALL: 'waterfall'
});


export const PAYMENT_TYPE = Object.freeze({
    VALIDATE: 'validate'
});
